import { Area } from "./Area";
import { DateTime_fromTransferable, DateTime_toTransferable } from "./DateTime";
import { GridSamplingStrategyKind } from "./GridSamplingStrategy";
const normalizeIsoParam = (value) => {
    if (typeof value !== "string") {
        return undefined;
    }
    const trimmed = value.trim();
    return trimmed.length ? trimmed : undefined;
};
/**
 * The API parameters `isoband_intervals`, `isoline_values`, and `isoline_range`
 * are mutually exclusive. Priority order:
 * 1) isoband_intervals
 * 2) isoline_values
 * 3) isoline_range
 */
export function selectExclusiveIsoBandAndLineParams(params) {
    const isobandIntervals = normalizeIsoParam(params.isobandIntervals);
    if (isobandIntervals) {
        return {
            isobandIntervals,
            isolineValues: undefined,
            isolineRange: undefined,
        };
    }
    const isolineValues = normalizeIsoParam(params.isolineValues);
    if (isolineValues) {
        return {
            isobandIntervals: undefined,
            isolineValues,
            isolineRange: undefined,
        };
    }
    const isolineRange = normalizeIsoParam(params.isolineRange);
    return {
        isobandIntervals: undefined,
        isolineValues: undefined,
        isolineRange,
    };
}
export function IsoLinesRequest_toTransferable(req) {
    return {
        ...req,
        area: req.area.toTransferable(),
        boundingBoxLimit: req.boundingBoxLimit ? req.boundingBoxLimit.toTransferable() : null,
        datetime: DateTime_toTransferable(req.datetime),
    };
}
export function IsoLinesRequest_fromTransferable(req) {
    return {
        ...req,
        area: Area.fromTransferable(req.area),
        boundingBoxLimit: req.boundingBoxLimit ? Area.fromTransferable(req.boundingBoxLimit) : null,
        datetime: DateTime_fromTransferable(req.datetime),
    };
}
export function IsoLinesRequest_toGridRequest(isoLinesRequest) {
    return {
        ...isoLinesRequest,
        parameters: [isoLinesRequest.parameter],
        sampling: { kind: GridSamplingStrategyKind.Point },
    };
}
//# sourceMappingURL=IsoLinesRequest.js.map